var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn",on:{"click":function($event){return _vm.displayPassword()}}},[(_vm.pass_is_displayed)?_c('i',{staticClass:"far fa-eye fa-lg"}):_c('i',{staticClass:"far fa-eye-slash fa-lg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }